<script setup>
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
</script>

<template>
  <div class="jwx-pro-forecast__message-banner jwx-pro-forecast__out-of-season-banner">
    <p class="jwx-pro-forecast__message-title">{{ t('containers.proForecast.outOfSeason') }}</p>
    <p class="jwx-pro-forecast__message-body">{{ t('containers.proForecast.restartsSpring') }}</p>
  </div>
</template>